import { reflect } from '@effector/reflect';
import { useUnit } from 'effector-react';
import { Trash2 } from 'lucide-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { breakpoints } from 'shared/lib';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import { DeleteDeviceModel } from '../../model';

export const createDeleteDeviceModal = (model: DeleteDeviceModel) => {
	const ConfirmModal = createConfirmModal(model);

	const DeleteDeviceModal = forwardRef<HTMLDivElement, ConfirmModalProps>(({ ...props }, ref) => {
		const { t } = useTranslation();

		const [md, device] = useUnit([breakpoints.md, model.$modalData]);

		return (
			<ConfirmModal
				ref={ref}
				title={t('delete-device.title')}
				submitButtonProps={{
					children: t('delete-device.delete'),
					leftSection: <Trash2 />,
					variant: 'destructive',
					size: md ? 'xl' : 'lg',
					fullWidth: true,
				}}
				size={md ? '2xl' : 'xl'}
				variant='default'
				{...props}
			>
				{t('delete-device.description', { name: device?.name ?? '' })}
			</ConfirmModal>
		);
	});

	const DeleteDeviceActionIcon = reflect({
		view: ConfirmModal.ActionIcon,
		bind: {
			variant: 'destructive',
			size: breakpoints.md.map((md) => (md ? 'xl' : 'lg')),
			children: <Trash2 />,
		},
	});

	return Object.assign(DeleteDeviceModal, {
		ActionIcon: DeleteDeviceActionIcon,
	});
};
